import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import LinkRoundedIcon from '@mui/icons-material/LinkRounded';

// The logos of the systems that are connected together, side by side with a link
// between them. A logo without an address, or that does not load, is left out, so
// the screen never shows a broken image.
export const LogosRow = ({ logos }) => {
  const [failed, setFailed] = useState([]);
  const shown = logos.filter(({ url }) => url && !failed.includes(url));

  if (!shown.length) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '20px',
        width: '100%',
        paddingBottom: '24px',
      }}
      data-testid="logos_row"
    >
      {shown.map(({ url, alt }, index) => (
        <React.Fragment key={url}>
          {index > 0 ? (
            <LinkRoundedIcon sx={{ color: '#9e9e9e' }} data-testid="logos_row_link" />
          ) : null}
          <Box
            component="img"
            src={url}
            alt={alt}
            onError={() => setFailed((previous) => [...previous, url])}
            sx={{ height: '64px', maxWidth: '140px', objectFit: 'contain' }}
            data-testid="logos_row_logo"
          />
        </React.Fragment>
      ))}
    </Box>
  );
};

LogosRow.propTypes = {
  logos: PropTypes.arrayOf(PropTypes.shape({ url: PropTypes.string, alt: PropTypes.string }))
    .isRequired,
};
